import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { ROOT_PATH } from './constants';

/**
 * This component should be used for all pages where the user should not enter
 * directly. Namely, in order to access a MidFlowRoute, the user must have gone in sequence
 * through the flow
 *
 * @param {*} props.children
 * @param {string} props.path
 * @param {string} props.fallbackPath Determines where to redirect page to if page was not entered
 *   through the flow's entry page
 */
export function MidFlowRoute({ children, path, enteredFlow }) {
  if (!enteredFlow) {
    return <Redirect to={ROOT_PATH} />
  }

  return <Route path={path}>{children}</Route>
}
